export default "__VITE_ASSET__db5ad73e__"